import { assign, get } from 'lodash';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { GET_TICKETS } from '../../apiConst';
import SelectDropdown from '../../Common/SelectDropdown';
import { taskStatusOptions } from '../../utils';
import { postRequest, putRequest } from '../interceptor/interceptor';
import FullScreenLoader from '../Loader/FullScreenLoader';
import { FaListUl, FaThLarge, FaTasks } from 'react-icons/fa';
import { VscTasklist } from 'react-icons/vsc';
import GmsList from './GmsList';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { IoMdAdd, IoMdSend } from 'react-icons/io';

export default function TicketsGms() {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [checked, setChecked] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(rowsPerPage);
  const [tableRowsData, setTableRowsData] = useState([]);
  const navigate = useNavigate();
  const { role, email } = useSelector((state) => state.user);

  const {
    register,
    getValues,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  useEffect(() => {
    fetchListData();
  }, [checked]);

  const fetchListData = (pg = 1, size = 10, search = '', searchKey = null) => {
    setIsLoading(true);
    if (checked) {
      let payload = {
        filter: {},
        sortOrder: -1,
        page: pg,
        pageSize: size,
      };
      const { searchField } = getValues();
      const key = searchKey ? searchKey : searchField;
      if (key && search) {
        payload.filter[key] = search;
      }
      postRequest(GET_TICKETS, payload)
        .then((res) => {
          console.log('res', res);
          const { result, totalCount } = res.data;
          setTableRowsData(result || []);
          setTotalCount(totalCount || result.length);
          setIsLoading(false);
          setIsDisplay(true);
        })
        .catch(() => {
          setIsLoading(false);
          setTableRowsData([]);
          setTotalCount(0);
        });
    } else {
      let payload = {
        filter: {},
        sortOrder: -1,
        page: pg,
        data: 'all',
        pageSize: size,
      };
      const { searchField } = getValues();
      const key = searchKey ? searchKey : searchField;
      if (key && search) {
        payload.filter[key] = search;
      }
      postRequest(GET_TICKETS, payload)
        .then((res) => {
          console.log('res', res);
          const { result, totalCount } = res.data;
          setTableRowsData(result || []);
          setTotalCount(totalCount || result.length);
          setIsLoading(false);
          setIsDisplay(true);
        })
        .catch(() => {
          setIsLoading(false);
          setTableRowsData([]);
          setTotalCount(0);
        });
    }
  };

  const onNewTask = () => {
    navigate('/AddGms', {
      state: {
        data: {},
      },
    });
  };

  const onEdit = (task) => {
    navigate('/AddGms', {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isEdit: true,
      },
    });
  };
  const onView = (task) => {
    navigate('/stepper-form', {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isView: true,
      },
    });
  };
  const onStepperForm = (task) => {
    navigate('/stepper-form', {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isView: false,
      },
    });
  };

  return (
    <>
      {isLoading && <FullScreenLoader />}

      <form>
        <div className="flex flex-col gap-2 lg:flex-row lg:justify-end">
          <div className="flex flex-col lg:flex-row gap-2 lg:gap-4 justify-center items-center">
            {[
              'Super-Admin',
              'Admin',
              'Grievance-Admin-Access',
              'Grievance-Manager-Access',
            ].includes(role) && (
              <>
                <label className="inline-flex items-center cursor-pointer">
                  <span className="me-3 text-sm font-medium text-gray-900">
                    All Requests 
                  </span>
                  <input
                    type="checkbox"
                    value=""
                    className="sr-only peer"
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                  />
                  <div className="relative w-11 h-6 bg-gray-800 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                  <span className="ms-3 text-sm font-medium text-gray-900">
                    My Requests 
                  </span>
                </label>

                <Button
                  className="w-full lg:w-48 lg:mr-3 bg-blueBg hover:bg-blueBg"
                  type="button"
                  onClick={() => onNewTask()}
                  variant="contained"
                 
                  startIcon={<IoMdAdd />}
                >
                  Add Request 
                </Button>
              </>
            )}
          </div>
        </div>
      </form>
      <GmsList
        tableRowsData={tableRowsData}
        getListData={fetchListData}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalCount={totalCount}
        page={page}
        setPage={setPage}
        onEdit={onEdit}
        onView={onView}
        onStepperForm={onStepperForm}
        register={register}
        errors={errors}
      />
    </>
  );
}
